var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 294"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 24.9179,
    cy: 24.7843,
    r: 24.6444,
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M30.5615 19.8674L20.0001 30.4289",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M30.5615 30.429L20.0001 19.8675",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDeclined);
export default __webpack_public_path__ + "static/media/DocumentDeclined.88156824d2430222cb8a450dde87bac6.svg";
export { ForwardRef as ReactComponent };